import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import queryString from 'query-string';

import Layout from '../ui/Layout';
import Loading from '../ui/Loading';
import fetchDux from '../../state/fetch-dux';

const chunk = array =>
  array.reduce(
    (r, v) =>
      (!r.length || r[r.length - 1].length === 2
        ? r.push([v])
        : r[r.length - 1].push(v)) && r,
    []
  );

const SCROLL_STEP = 80;

class WhatWeDo extends Component {
  constructor(props) {
    super(props);
    this.state = { isPreview: false, scrollPOS: 0 };
    this.scrollRef = null;
    this.scrollRefContainer = null;
    this.setSrollRef = this.setSrollRef.bind(this);
    this.setScrollContainer = this.setScrollContainer.bind(this);
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    const qs = queryString.parse(this.props.location.search) || {};
    this.props.getContent({
      page: 'what-we-do',
      preview: qs.preview
    });
    this.setState({ isPreview: !!qs.preview });
  }
  componentWillUnmount() {
    this.props.clearGetContent();
  }
  setScrollContainer(ref) {
    this.scrollRefContainer = ref;
    this.forceUpdate();
  }
  setSrollRef(ref) {
    this.scrollRef = ref;
    this.forceUpdate();
  }
  render() {
    const { scrollPOS, isPreview } = this.state;
    const { result, inProgress } = this.props;
    const { data, versionName } = result || {};

    const scrollSectionUp = () => {
      const next = scrollPOS + SCROLL_STEP > 0 ? 0 : scrollPOS + SCROLL_STEP;
      this.setState({ scrollPOS: next });
    };

    const scrollSectionDown = () => {
      const { clientHeight: sectionHeight } = this.scrollRef || {};
      const { clientHeight: containerHeight } = this.scrollRefContainer || {};
      const next = sectionHeight + (scrollPOS - SCROLL_STEP) < containerHeight
        ? containerHeight - sectionHeight - 20
        : scrollPOS - SCROLL_STEP;
      this.setState({ scrollPOS: next });
    };
    return (
      <Layout
        route="what-we-do"
        isPreview={isPreview}
        versionName={versionName}
      >
        {inProgress && <Loading />}
        {!inProgress &&
          data &&
          <main>

            <Grid>
              <Row>
                <Col sm={12}>

                  <section className="box-text">
                    <article>
                      <div
                        className="image"
                        style={{
                          backgroundImage: `url(${(data.images || {}).href})`
                        }}
                      />
                      <h2>{data.tagline}</h2>
                      <h1>{data.title}</h1>
                      <p>{data.description}</p>
                    </article>
                    <Parallax
                      offsetYMax={10}
                      offsetYMin={-10}
                      className="triangle"
                    />
                    <div className="line" />
                  </section>

                  {data.userApplications.length &&
                    <section className="box-applications">
                      <h3>User Applications</h3>
                      {chunk(data.userApplications).map((group, index) => (
                        <Row key={index}>
                          {group.map((application, i) => (
                            <Col sm={6} key={i}>
                              <article>
                                <h4>{application.header}</h4>
                                <p>{application.content}</p>
                              </article>
                            </Col>
                          ))}
                        </Row>
                      ))}
                    </section>}

                  <section className="box-results">
                    <div
                      className="headers"
                      style={{
                        backgroundImage: `url(${(data.slider || {}).images.href})`
                      }}
                    >
                      <h3>{data.slider.header}</h3>
                      <h4>{data.slider.tagline}</h4>
                    </div>
                    <div className="text">
                      <div className="scroll" ref={this.setScrollContainer}>
                        <div
                          ref={this.setSrollRef}
                          className="scroll-inner"
                          style={{
                            transform: `translate3d(0,${scrollPOS}px,0)`
                          }}
                        >
                          {(data.slider || {}).sliderSections &&
                            data.slider.sliderSections.map((slide, index) => (
                              <article key={index}>
                                <h5>{slide.header}</h5>
                                <p>{slide.content}</p>
                              </article>
                            ))}
                        </div>
                      </div>
                      <div className="controls">
                        <div className="up" onClick={scrollSectionUp} />
                        <div className="down" onClick={scrollSectionDown} />
                      </div>
                    </div>
                  </section>

                </Col>
              </Row>
            </Grid>

          </main>}
      </Layout>
    );
  }
}

const mapState = state => state.getContent.toJS();

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      getContent: fetchDux.getContent.createAction,
      clearGetContent: fetchDux.getContent.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(WhatWeDo);



// WEBPACK FOOTER //
// ./src/components/routes/WhatWeDo.js